import classes from "./Service.module.css";
import { motion } from "framer-motion";
import { useEffect } from "react";

const Service = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: "0.1" } }}
      className={classes.service}
    >
      <hgroup className={classes.service__heading}>
        <h2 className={classes.highlight}>我們的服務</h2>
        <h4>十年的經驗累積，從規劃、設計、生產到加工，都能掌握每個細節。</h4>
      </hgroup>
      <div className={classes.service__container}>
        <div className={` ${classes.service__part} ${classes.service__part1}`}>
          <div className={classes.detail}>
            <div className={classes.service__title}>
              <h3>規劃</h3>
            </div>
            <div className={classes.service__desc}>
              <ul>
                <li>禮贈品規劃</li>
                <li>股東會贈品提案</li>
                <li>促銷贈品提案</li>
              </ul>
            </div>
          </div>
        </div>
        <div className={`${classes.service__part} ${classes.service__part2}`}>
          <div className={classes.detail}>
            <div className={classes.service__title}>
              <h3>設計</h3>
            </div>
            <div className={classes.service__desc}>
              <ul>
                <li>產品細節設計</li>
                <li>股東會贈品提案</li>
                <li>促銷贈品提案</li>
              </ul>
            </div>
          </div>
        </div>
        <div className={`${classes.service__part} ${classes.service__part3}`}>
          <div className={classes.detail}>
            <div className={classes.service__title}>
              <h3>生產</h3>
            </div>
            <div className={classes.service__desc}>
              <ul>
                <li>禮贈品規劃</li>
                <li>股東會贈品提案</li>
                <li>促銷贈品提案</li>
              </ul>
            </div>
          </div>
        </div>
        <div className={`${classes.service__part} ${classes.service__part4}`}>
          <div className={classes.detail}>
            <div className={classes.service__title}>
              <h3>加工</h3>
            </div>
            <div className={classes.service__desc}>
              <ul>
                <li>生產後處理</li>
                <li>售後提供服務</li>
                <li>促銷贈品提案</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Service;
